import { gql, useQuery } from '@apollo/client'

import { useGetNewestData } from '@/clients/utoniq-core'
import {
  PaymentStatusesQuery,
  PaymentStatusesQueryVariables,
  PendingPurchaseItemDetailFragmentDoc,
  PendingPurchaseItemsConnectionFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { isFirstLoadRef } = useGetNewestData<
    PaymentStatusesQuery,
    PaymentStatusesQueryVariables
  >({
    query: QUERY,
    variables: {},
    fields: [
      {
        fieldName: 'pendingPurchaseItems',
        fragmentName: 'PendingPurchaseItemDetail',
        fragment: PendingPurchaseItemDetailFragmentDoc,
      },
    ],
  })

  const { data, loading, fetchMore } = useQuery<
    PaymentStatusesQuery,
    PaymentStatusesQueryVariables
  >(QUERY, {
    variables: {},
    fetchPolicy: 'cache-first',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    onCompleted() {
      isFirstLoadRef.current = false
    },
  })

  return {
    state: {
      loading,
      pendingPurchaseItems: data?.pendingPurchaseItems ?? null,
      hasNextPage: !!data?.pendingPurchaseItems.pageInfo.hasNextPage,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            pageInput: {
              cursor: data?.pendingPurchaseItems.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query PaymentStatuses($pageInput: PageInputDate) {
    pendingPurchaseItems(pageInput: $pageInput) {
      ...PendingPurchaseItemsConnection
    }
  }
  ${PendingPurchaseItemsConnectionFragmentDoc}
`
